import ROUTES from 'routes';

export const adminPermission = {
  // Empty is can access to every routes
  urls: [],
  excludeUrls: [ROUTES.MY_COMPANY()],
  hasNotification: true,
};
